module.exports = __webpack_public_path__ + "img/logo-header.7e01c596.png";